import { JSX, createContext, useContext } from "solid-js";
import { useView } from "../hooks/use_view";

type ViewContextType = ReturnType<typeof useView>;

const ViewContext = createContext<ViewContextType>();

export function useViewContext(): ViewContextType {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error("useViewContext must be used within ViewProvider");
  }
  return context;
}

export function ViewProvider(props: {
  children: JSX.Element;
  value: ViewContextType;
}) {
  return (
    <ViewContext.Provider value={props.value}>
      {props.children}
    </ViewContext.Provider>
  );
}
